module.exports = __webpack_public_path__ + "img/ico-detail.3e6f7b94.png";